import React from 'react'
import { Modal } from 'react-bootstrap'
import { useClientContext } from '../../../../_context/ClientContext'

export const ClientUpdatedSuccessModal = () => {

    const{setClientUpdated,clientUpdated} = useClientContext()

  return (
    <Modal
    show={clientUpdated}
    size="xl"
    aria-labelledby="contained-modal-title-vcenter"
    centered
    onHide={() => setClientUpdated(false)}
    >
        <Modal.Header  closeButton onHide={() => setClientUpdated(false)}>
           <Modal.Title>Success</Modal.Title> 
        </Modal.Header>
        <Modal.Body>
            Client Updated Successfully
        </Modal.Body>
    </Modal>
  )
}
